import React from 'react'

import { Layout, Showcase, SectionTitle, Header } from '../../../../components'

import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      />
      <Layout
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      >
        <SectionTitle>Variants</SectionTitle>

        <Showcase
          site={data.site}
          title="Input Chip"
          text="Input chips represent user-entered or selected information and appear inline within a text input or textarea."
          code={code.chipBase}
        >
          <div class="c-chip__container">
            <div class="c-chip c-chip--active">
              Lorem Ipsum
              <div class="c-chip__icon">
                <i class="icon icon--close"></i>
              </div>
            </div>
          </div>
        </Showcase>
      </Layout>
    </>
  )
}

export const code = {
  chipBase: `<div class="c-chip__container">
  <div class="c-chip c-chip--active">
  Lorem Ipsum
    <div class="c-chip__icon">
      <i class="icon icon--close"></i>
    </div>
  </div>
</div>`,
}
